export default __webpack_public_path__ + "static/media/two_people_charging.01782af5.png";